import { toISODate } from "../../utils/date";

/**
 * Valores iniciais do formulário de Workout.
 */
export const initialWorkoutState = (date) => ({
    title: "",
    date: date || toISODate(new Date()),
    description: "",
    blocks: [
        {
            id: Date.now().toString(),
            name: "Aquecimento",
            sets: []
        },
        {
            id: (Date.now() + 1).toString(),
            name: "Principal",
            sets: []
        },
        {
            id: (Date.now() + 2).toString(),
            name: "Soltura",
            sets: []
        }
    ]
});

export const templateWorkoutState = (date) => ({
    title: "Treino Aeróbico (Modelo)",
    date: date || toISODate(new Date()),
    description: "Foco principal no desenvolvimento da base aeróbica e ritmo constante.",
    blocks: [
        {
            id: Date.now().toString() + "1",
            name: "Aquecimento",
            sets: [
                { id: "set-" + Date.now() + "1", reps: 1, distance: 400, style: "Livre", intensity: "A1", interval: "Direto", description: "Nado contínuo leve" },
                { id: "set-" + Date.now() + "2", reps: 4, distance: 50, style: "Borboleta", intensity: "A2", interval: "15''", description: "Educativos" }
            ]
        },
        {
            id: Date.now().toString() + "2",
            name: "Principal",
            sets: [
                { id: "set-" + Date.now() + "3", reps: 8, distance: 100, style: "Livre", intensity: "A2", interval: "1'30\"", description: "Manter ritmo de prova" },
                { id: "set-" + Date.now() + "4", reps: 4, distance: 200, style: "Livre", intensity: "A3", interval: "3'15\"", description: "Com palmar e flutuador" }
            ]
        },
        {
            id: Date.now().toString() + "3",
            name: "Soltura",
            sets: [
                { id: "set-" + Date.now() + "5", reps: 1, distance: 200, style: "Costas", intensity: "A1", interval: "Direto", description: "Relaxando musculatura" }
            ]
        }
    ]
});
